// @ts-nocheck
import ClickableOrderCodes from "components/shared-components/ClickableOrderCodes";
import LoadingTableNormal from "components/shared-components/LoadingTableNormal";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle, Table } from "reactstrap";
import "../OrderDetailHistory/OrderDetailHistory.scss";
const OrderDetailHistory = props => {
  const { t } = useTranslation(["order"]);
  const [data, setData] = useState(props.data);
  const [isLoading, setIsLoading] = useState(props.isLoading);
  const [status, setStatus] = useState(props.status);

  useEffect(() => setData(props.data), [props.data]);
  useEffect(() => setIsLoading(props.isLoading), [props.isLoading]);
  useEffect(() => setStatus(props.status), [props.status]);

  return (
    <Card>
      <CardBody>
        <CardTitle>{t("detail.history.title")}</CardTitle>
        {isLoading ? (
          <LoadingTableNormal countColumn="5" countRow="3" />
        ) : (
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead>
                <tr>
                  <th>No</th>
                  <th>{t("detail.history.date")}</th>
                  <th>{t("detail.history.name")}</th>
                  <th>{t("detail.history.action")}</th>
                  <th>{t("detail.history.note")}</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data?.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <th scope="row">{index + 1}</th>
                        <td>
                          {moment
                            .unix(new Date(Number(item?.maker_date)))
                            .format("DD/MM/YYYY HH:mm:ss")}
                        </td>
                        <td>{item?.maker_name}</td>
                        <td>{status[item?.to_status - 1]?.label}</td>
                        <td>
                          <div>
                            <div className="text-info">
                              <ClickableOrderCodes text={item?.note} />
                            </div>
                            <div className="text-primary">
                              <ClickableOrderCodes
                                text={item?.shipping_history}
                              />
                              {item?.images && item.images.length > 0 && (
                                <div className="text-info">
                                  {item.images.map((image, index) => (
                                    <a
                                      className="text-warning"
                                      style={{
                                        marginRight: "10px",
                                        borderBottom: "1px solid",
                                      }}
                                      key={index}
                                      href={image}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Image {index + 1}
                                    </a>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="text-center" colSpan="5">
                      {t("detail.history.table_empty")}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

OrderDetailHistory.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  status: PropTypes.array,
};
export default OrderDetailHistory;
